// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"29":"c54cb002","179":"4e1ee0a3","259":"c460c617","416":"54ee2a79","477":"108ddac6","685":"7b006339","970":"9798a88d"}[chunkId] + ".js";
};